import { useInfiniteQuery } from "react-query";
import axios from "infra/http";
import { PaginateResult } from "core/resources/types/shared";
import { ContaRecorrenteParams, ContaRecorrenteItem } from "../typings";

function useContasRecorrentes(params: ContaRecorrenteParams) {
  return useInfiniteQuery(
    [`/v1/conta-recorrente`, params],
    async ({ pageParam }) => {
      const { data } = await axios.get<PaginateResult<ContaRecorrenteItem>>(
        `/v1/conta-recorrente`,
        {
          params: {
            ...params,
            page: pageParam,
          },
        }
      );

      return data;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage === lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}

export default useContasRecorrentes;
